import { useDispatch } from "react-redux";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";

import { TiVoPublications } from "./types";

export const useUpdateVariantPublications = (
  id?: string,
  variantId?: string
) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation<void, Error, Pick<TiVoPublications, "platforms">>({
    mutationFn: async (data) => {
      return dispatch(
        apiThatThrows.updateTiVoVariantPublications.action({
          params: { id, variantId },
          options: {
            body: JSON.stringify({
              data: {
                type: "string",
                attributes: {
                  ...data,
                },
                id: variantId,
              },
            }),
          },
        })
      );
    },
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ["variantPublications", id, variantId],
      });
    },
  });
};
